export const ACTIVATE_NAVIGATION = 'page/NAVIGATION [activate]';
export const NAVIGATION_READY = 'page/NAVIGATION [ready]';
